import { render, staticRenderFns } from "./SendRepeatTip.vue?vue&type=template&id=00b94049&scoped=true"
import script from "./SendRepeatTip.vue?vue&type=script&lang=js"
export * from "./SendRepeatTip.vue?vue&type=script&lang=js"
import style0 from "./SendRepeatTip.vue?vue&type=style&index=0&id=00b94049&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b94049",
  null
  
)

export default component.exports